<cx-global-message aria-atomic="true" aria-live="assertive" class="personalDetailsMsg" [isInnerHtmlEnable]="true"></cx-global-message>
<div   class="custom-personal-details-form d-flex flex-column" >
    <div class="personal-header" >
        {{ "personalDetails.title" | cxTranslate }}
    </div>
    <div class="personal-header-two" >
        {{ "personalDetails.header" | cxTranslate }}
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.role" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
       {{getRoleType(userData.roles && userData.roles.length ? userData.roles: [] )}} 
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.salutation" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
        {{ userData.title }}
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.firstName" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
        {{ userData.firstName }}
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.lastName" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
        {{ userData.lastName }}
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.soldto" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
        {{ userData.orgUnit ? userData.orgUnit.name : ''}}
    </div>
    <div class="personal-header-three" >
        {{ "personalDetails.email" | cxTranslate }}
    </div>
    <div class="personal-header-four" >
        {{ userData.displayUid }}
    </div>
</div>
